import React, { useState } from "react";
import "./active.css";
import axios from "../../../../axios";
import { toast } from "react-toastify";

const Delete = ({
  setDelete,
  assessmentId,
  setDeactiveProcess,
  isForDraft,
  getDraftAssessment
}) => {
  const [errorText, setErrorText] = useState("");
  let teacher_id = JSON.parse(localStorage.getItem("Teacher_id"));
  const [isInProgress, setIsInProgress] = useState(false);
  const handleDelete = async () => {
    setIsInProgress(true);
    try {
      let res = await axios.delete(
        `/api/v1/assessment/delete/${assessmentId}`,
        {
          data: {
            teacher_id: teacher_id,
          },
        }
      );

      res && isForDraft
        ? getDraftAssessment()
        : res && setDeactiveProcess((prev) => !prev);
      setDelete(false);
      res && toast.success("Assessment Deleted Successfully")
      if (window.location.pathname !== '/publishedAssessment') {
        window.location.pathname = '/publishedAssessment'
      }
    } catch (error) {
      setIsInProgress(false);
      setErrorText(error.response.data.message)
      console.log(error);
    }
  };

  return (
    <div className="published_Deative_transprant_body">
      <div className="published_Deative_preview_container">
        <img
          className="deactive_closeBtn"
          src="/images/cross-circle3.svg"
          alt=""
          onClick={(e) => setDelete(false)}
        />
        <div className="col-12 deactivate_msg">
          Are you sure you want to delete this assessment?
          {errorText !== "" && <p style={{ color: "red" }}>{errorText}</p>}
        </div>
        <div className="row col-12 publish_deactive_btnBox">
          <button
            onClick={handleDelete}
            disabled={isInProgress}
            className="btn col-sm-5 my-1 deactive_sure_btn"
          >
            Yes
          </button>
          <button
            disabled={isInProgress}
            className="btn col-sm-5 my-1 deactive_sure_btn"
            onClick={(e) => setDelete(false)}
          >
            No
          </button>
        </div>
      </div>
    </div>
  );
};

export default Delete;
